import { fetchAPI } from "../general/BuddyFuncs";

export default class RefreshMeeting {
  constructor(
    params = {
      binarWaitingSelector: "",
      apiUrl: "",
    }
  ) {
    this.binarWaitingSelector = params.binarWaitingSelector;
    this.binarWaiting = null;

    this.apiUrl = params.apiUrl;
  }

  init() {
    this.binarWaiting = document.querySelector(this.binarWaitingSelector);

    if (this.binarWaiting) {
      //refresh page once time is met
      this.setRefresh();
    }
  }

  setRefresh() {
    fetchAPI(this.apiUrl).then((r) => {
      if (r.status) {
        if (r.status === "waiting") {
          //event not online yet
          const now = new Date(r.currentTime);
          const startTime = new Date(r.startTime);

          setTimeout(() => {
            this.refreshPage(r.refreshUrl);
          }, startTime - now);
        } else if (r.status === "ended") {
          //event has ended
          this.refreshPage(r.refreshUrl);
        } else if (r.status === "meeting") {
          //event is live refresh
          this.refreshPage(r.refreshUrl);
        }
      }
    });
  }

  refreshPage(redirectLink) {
    window.location.href = redirectLink;
  }
}
